import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow } from '@material-ui/core';import { withStyles } from '@material-ui/core/styles';
import React from 'react';

const styles = theme => ({
  paper: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(2),
    minWidth: 230,
  },
  flex: {
    display: 'flex',
  },
});

class FormDialogCarencia extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.carencias,
    };
  }
componentDidMount = async () => {
}
  render () {
    const { classes, open, handleClose, carencias } = this.props;
    return (
      <div>
        <Dialog
          maxWidth='sm'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>Carências</DialogTitle>
            <div>
              <DialogContent>
                {carencias.length !== 0
              ? <Paper className={classes.body} elevation={1}>
              <FormControl>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell title='Situação do Acerto'>Carência</TableCell>
                      <TableCell title='Nome do Usuário'>Data Fim</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {carencias.map((carencia, idx) => {
                      return (
                        <TableRow
                          key={idx}>
                          <TableCell>{carencia.desTipoCarencia}</TableCell>
                          <TableCell>{carencia.desCondicaoAdmissao}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </FormControl>
            </Paper>
            : <Paper>
              Não há carências cadastradas para este beneficiário
              </Paper>}
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color='primary' id={'fechar'}>
                  Fechar
                </Button>
              </DialogActions>
            </div>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogCarencia);
